export default __webpack_public_path__ + "static/media/phrase-game-gameplay.d2b261c6.png";